import { APP_NAME } from 'src/js/constants/common';
import track from '../helpers/track';
import eventTypes from '../constants/event-types';

const trackSiteSetupBackToTopClicked = ({
  siteId,
  stepId,
  businessCategory = null,
  archetypeId,
}) => {
  track(eventTypes.SITESETUP_BACK_TO_TOP_CLICKED, {
    appName: APP_NAME,
    siteId,
    stepId,
    businessCategory,
    archetypeId,
  });
};

export default trackSiteSetupBackToTopClicked;
